// Controls
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, useTheme } from "@fluentui/react";
// Utilities
import * as React from "react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { getClassNames, getStyles, getDialogStyles, checkUnsavedApprovalDialogWidth } from "./CheckUnsavedApprovalDialog.styles";
export function CheckUnsavedApprovalDialog(props) {
    const theme = useTheme();
    const { callbacks } = props;
    const { dialog, dialogButtons } = getClassNames(getStyles(theme));
    const dialogContentProps = {
        type: DialogType.normal,
        title: Strings.AddApprover_CheckUnsavedApprovalDialog_CheckUnsavedApprovalDialog_Title,
        closeButtonAriaLabel: Strings.SharedComponents_CloseButtonText,
        subText: Strings.AddApprover_CheckUnsavedApprovalDialog_CheckUnsavedApprovalDialog_Text,
        styles: getDialogStyles(theme)
    };
    const modalProps = {
        isBlocking: true,
        className: dialog
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        hidden: false,
        onDismiss: callbacks.onCloseDialog,
        dialogContentProps: dialogContentProps,
        modalProps: modalProps,
        minWidth: checkUnsavedApprovalDialogWidth
    }, /*#__PURE__*/ React.createElement(DialogFooter, null, /*#__PURE__*/ React.createElement(PrimaryButton, {
        onClick: callbacks.onSendRequest,
        text: Strings.AddApprover_CheckUnsavedApprovalDialog_CheckUnsavedApprovalDialog_SendRequest,
        className: dialogButtons
    }), /*#__PURE__*/ React.createElement(DefaultButton, {
        onClick: callbacks.onDiscard,
        text: Strings.AddApprover_CheckUnsavedApprovalDialog_CheckUnsavedApprovalDialog_Discard,
        className: dialogButtons
    })));
}
